export default __webpack_public_path__ + "static/media/list-rounded.3b4f989e.svg";